import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth';
import 'firebase/storage'
import 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyDI-I7TOrK1YJiqg6or6saAFn5KoB1gAUc",
    authDomain: "shield-staged.firebaseapp.com",
    projectId: "shield-staged",
    storageBucket: "shield-staged.appspot.com",
    messagingSenderId: "1091291310386",
    appId: "1:1091291310386:web:723a7812865fc623908f2b"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;